import React from "react";

import { Table, Button } from "antd";

function CampaignList(props) {
  // const [campaignList, setCampaignList] = React.useState([]);

  // useEffect(() => {
  //   const loadCampaigns = ()=>{
  //     let c1 = props.loadCampaigns();
  //     return c1;
  //   }

  // 	let c1 = loadCampaigns();
  //   setCampaignList(c1);
  // }, []);

  return (
    <div key={props.ind}>
      <Table
        columns={[
          {
            dataIndex: "CampaignId",
            title: "Campaign Id",
          },

          {
            dataIndex: "CampaignFlightBudget",
            title: "Campaign Flight Budget",
          },

          {
            dataIndex: "CampaignFlightStartDateString",
            title: "Campaign Flight Start Date",
          },

          {
            dataIndex: "CampaignFlightEndDateString",
            title: "Campaign Flight End Date",
          },

          {
            dataIndex: "GoalType",
            title: "Goal Type",
          },
          // {
          //   dataIndex: "GoalValue",
          //   title: "Goal Value",
          // },
          {
            dataIndex: "OutcomeNeeded",
            title: "Flight Outcome Goal",
          },
          {
            dataIndex: "AdditionalEmails",
            title: "Additional Emails (Optional)"
          },
          {
            title: "Actions",
            render: (id, campaign, index) => (
              <div>
                {/* <SecondaryButton
                  as="button"
                  className="btn-space"
                  onClick={() => props.showEditForm(index)}
                >
                  Edit
                </SecondaryButton> */}
                <Button
                  as="button"
                  className="btn-space"
                  onClick={() => props.deleteCampaign(campaign)}
                >
                  Delete
                </Button>
              </div>
            ),
          },
        ]}
        data-ttd-inspect-id="campaign_list_table"
        dataSource={props.campaignList}
        rowKey="index"
        rowStyle={{
          height: "standard",
        }}
        pagination={{
          pageSizeOptions: [5, 25, 50, 100],
          pageSize: 100,
        }}
      />
    </div>
  );
}

export default CampaignList;
